<template>
  <ol
    class="scrollbar scrollbar-track-gray scrollbar-thumb-violet scrollbar-h-[2px] flex items-center overflow-x-auto text-sm"
  >
    <li
      v-for="(crumb, index) in crumbs"
      :key="crumb.name"
      class="inline-flex items-center pb-1"
    >
      <Link
        v-if="crumb.link"
        :routeName="crumb.link"
        class="whitespace-nowrap text-info no-underline hover:underline hover:brightness-50"
        >{{ $t(crumb.name) }}</Link
      >
      <a
        v-else-if="crumb.external_link"
        :href="crumb.external_link"
        class="whitespace-nowrap text-gray hover:underline hover:brightness-50"
        >{{ $t(crumb.name) }}
      </a>
      <span v-else class="whitespace-nowrap text-gray">{{
        $t(crumb.name)
      }}</span>

      <div v-if="index < crumbs.length - 1" class="w-6 px-2">
        <inline-svg
          :src="require('@/assets/images/base/icons/arrow.svg')"
          class="h-[10px] text-gray"
        />
      </div>
    </li>
  </ol>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Link from "../Auth/Link.vue";
import InlineSvg from "vue-inline-svg";
export default {
  name: "BreadCrumbs",
  components: { InlineSvg, Link },
  computed: { ...mapGetters({ crumbs: "breadcrumbs/getFilledCrumbs" }) },
  methods: {
    updateList() {
      this.setCrumbs(this.$route.meta.breadcrumb ?? []);
    },
    ...mapMutations({
      setCrumbs: "breadcrumbs/setCrumbs",
    }),
  },
  watch: {
    "$route.meta.breadcrumb"() {
      this.updateList();
    },
  },
  mounted() {
    this.updateList();
  },
};
</script>
